import { AsyncPipe, DOCUMENT, Location, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { map, Observable } from 'rxjs';
import { EllipsisTooltipDirective } from 'src/app/common/ellipsis-tooltip/ellipsis-tooltip.directive';
import { HeaderComponent } from 'src/app/_shared/components/header/header.component';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { METADATA_SERVICE, MetadataService } from 'src/app/common/metadata/metadata.service';
import { OpenDialogService } from 'src/app/common/open-dialog/open-dialog.service';
import { ScrollableElementsComponent } from 'src/app/_shared/components/scrollable-elements/scrollable-elements.component';
import { SearchGalleryComponent } from 'src/app/_shared/components/search-gallery/search-gallery.component';
import { UserService } from 'src/app/common/user/user.service';
import { ViewportDirective } from 'src/app/common/viewport/viewport.directive';
import { Random } from 'src/types/graphql';
import { FooterComponent } from '../../_shared/components/footer/footer.component';
import { LoadingComponent } from '../../_shared/components/loading/loading.component';
import { UserNamePipe } from '../../common/user-name/user-name.pipe';
import { HomepageRankingGQL } from '../explore/explore.query.generated';
import { SlugPipe } from '../../_shared/pipes/slug.pipe';

@Component({
  selector: 'sharry-cherry-meter',
  standalone: true,
  templateUrl: './cherry-meter.component.html',
  styleUrl: './cherry-meter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    FooterComponent,
    I18NextModule,
    MatButtonModule,
    AsyncPipe,
    IconComponent,
    ScrollableElementsComponent,
    NgTemplateOutlet,
    RouterLink,
    ViewportDirective,
    SearchGalleryComponent,
    LoadingComponent,
    UserNamePipe,
    SlugPipe,
    NgClass,
    EllipsisTooltipDirective,
  ],
})
export class CherryMeterComponent implements OnInit, OnDestroy {
  cards: {
    text: string;
    icon: string;
    amount: number;
    type: 'phosphor' | 'custom';
  }[] = [
    {
      text: 'cherry-meter.cards.signin',
      icon: 'sign-in',
      amount: 1,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.purchase',
      icon: 'handbag',
      amount: 1,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.comment',
      icon: 'chat-circle-dots',
      amount: 1,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.like',
      icon: 'bello',
      amount: 1,
      type: 'custom',
    },
    {
      text: 'cherry-meter.cards.signup',
      icon: 'user',
      amount: 10,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.invite-friend',
      icon: 'users',
      amount: 10,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.wonder',
      icon: 'wonder-star',
      amount: 10,
      type: 'custom',
    },
    {
      text: 'cherry-meter.cards.write-wonder',
      icon: 'star',
      amount: 10,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.post',
      icon: 'note-pencil',
      amount: 1,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.share',
      icon: 'share-network',
      amount: 1,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.profile-complete',
      icon: 'user-full',
      amount: 1,
      type: 'custom',
    },
    {
      text: 'cherry-meter.cards.follower',
      icon: 'user-plus',
      amount: 1,
      type: 'phosphor',
    },
    {
      text: 'cherry-meter.cards.quiz',
      icon: 'quiz',
      amount: 1,
      type: 'custom',
    },
  ];

  public homepageRanking$: Observable<Random>;

  constructor(
    private renderer: Renderer2,
    private homepageRankingGQL: HomepageRankingGQL,
    public userService: UserService,
    private openDialogService: OpenDialogService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(METADATA_SERVICE) private metadataService: MetadataService,
    private location: Location,
  ) {
    this.homepageRanking$ = this.homepageRankingGQL
      .fetch({}, { fetchPolicy: 'no-cache' })
      .pipe(map(r => r.data.homepageRanking as Random));
  }

  ngOnInit(): void {
    this.renderer.addClass(this.document.querySelector('html'), 'shrink');
    this.metadataService.setMetadataPage('cherry-meter', this.location.path());
  }

  openDiscountsModal(): void {
    import('../../_shared/dialogs/available-discounts-dialog/available-discounts-dialog.component').then(
      ({ AvailableDiscountsDialogComponent }) =>
        this.openDialogService.openDialog(AvailableDiscountsDialogComponent, {
          ...{
            autoFocus: false,
            restoreFocus: false,
            minWidth: '50vw',
            maxHeight: '84vh',
          },
        }),
    );
    return;
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.querySelector('html'), 'shrink');
  }
}
